const PICKER_SELECTOR =
  'variant-picker[data-variant-style="quantity_cards"][data-enable-quantity-colors="true"]';

/** @type {Map<string, Map<string, string[]>>} */
const selections = new Map();

function pickerKey(picker) {
  return `${picker.dataset.sectionId || ''}:${picker.dataset.blockId || ''}:${picker.dataset.productId || ''}`;
}

function getProductForm(picker) {
  const scope = picker.closest('.product-details, .product-information, .shopify-section') || document;
  return scope.querySelector('form[action*="/cart/add"]');
}

function getSelectedItem(picker) {
  return Array.from(picker.querySelectorAll('[data-quantity-card-item]')).find((item) =>
    item.querySelector('.quantity-card > input:checked')
  );
}

function getDefaultColor(picker, item) {
  return (
    picker.querySelector('[data-bundle-source-color]:checked')?.value ||
    item?.querySelector('[data-color-choice]:not(:disabled)')?.dataset.colorValue ||
    ''
  );
}

function getItemSelections(picker, item) {
  const key = pickerKey(picker);
  const quantityValue = item.dataset.quantityValue || '';
  const unitCount = Math.max(1, Number.parseInt(item.dataset.unitCount || '1', 10));
  const defaultColor = getDefaultColor(picker, item);

  if (!selections.has(key)) selections.set(key, new Map());
  const pickerSelections = selections.get(key);
  const stored = pickerSelections.get(quantityValue) || [];

  while (stored.length < unitCount) stored.push(defaultColor);
  stored.length = unitCount;
  pickerSelections.set(quantityValue, stored);

  return stored;
}

function syncFormProperties(picker, colors) {
  const form = getProductForm(picker);
  if (!form) return;

  form.querySelectorAll('[data-quantity-card-property]').forEach((input) => input.remove());

  const propertyName = picker.dataset.colorPropertyName || 'Cor';
  colors.forEach((color, index) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${propertyName} ${index + 1}]`;
    input.value = color;
    input.dataset.quantityCardProperty = 'true';
    form.appendChild(input);
  });
}

function renderPicker(picker) {
  const selectedItem = getSelectedItem(picker);
  if (!selectedItem) return;

  const colors = getItemSelections(picker, selectedItem);
  const summary = selectedItem.querySelector('[data-color-selection-summary]');

  if (summary) {
    summary.textContent = colors.filter(Boolean).join(' + ');
  }

  selectedItem.querySelectorAll('[data-color-row]').forEach((row) => {
    const index = Math.max(0, Number.parseInt(row.dataset.unitIndex || '1', 10) - 1);
    const selectedColor = colors[index] || '';

    row.querySelectorAll('[data-color-choice]').forEach((button) => {
      const selected = button.dataset.colorValue === selectedColor;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  });

  syncFormProperties(picker, colors);
}

function renderAll() {
  document.querySelectorAll(PICKER_SELECTOR).forEach(renderPicker);
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('[data-color-choice]');
  if (!button) return;

  const picker = button.closest(PICKER_SELECTOR);
  const item = button.closest('[data-quantity-card-item]');
  const row = button.closest('[data-color-row]');
  if (!picker || !item || !row || button.disabled) return;

  event.preventDefault();

  const colors = getItemSelections(picker, item);
  const index = Math.max(0, Number.parseInt(row.dataset.unitIndex || '1', 10) - 1);
  const color = button.dataset.colorValue || '';
  colors[index] = color;

  const key = pickerKey(picker);
  selections.get(key)?.set(item.dataset.quantityValue || '', colors);

  // Atualiza o destaque antes de qualquer troca de variante ou requisição do tema.
  renderPicker(picker);

  // A primeira cor também controla a variante real, mantendo imagem, estoque e URL coerentes.
  if (index === 0) {
    const sourceInput = Array.from(picker.querySelectorAll('[data-bundle-source-color]')).find(
      (input) => input.value === color
    );
    if (sourceInput && !sourceInput.checked) {
      sourceInput.checked = true;
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

}, true);

document.addEventListener('change', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const picker = target?.closest(PICKER_SELECTOR);
  if (!picker || !target.closest('[data-quantity-card-option]')) return;
  requestAnimationFrame(() => renderPicker(picker));
});

document.addEventListener('variant:update', (event) => {
  const picker = event.target.closest?.(PICKER_SELECTOR) || event.target.querySelector?.(PICKER_SELECTOR);
  requestAnimationFrame(() => {
    if (picker?.isConnected) renderPicker(picker);
    else renderAll();
  });
});

document.addEventListener('shopify:section:load', renderAll);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderAll, { once: true });
} else {
  renderAll();
}
